import { render, staticRenderFns } from "./registerLocation.vue?vue&type=template&id=e6bd5aa0&scoped=true&"
import script from "./registerLocation.vue?vue&type=script&lang=js&"
export * from "./registerLocation.vue?vue&type=script&lang=js&"
import style0 from "./registerLocation.vue?vue&type=style&index=0&id=e6bd5aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6bd5aa0",
  null
  
)

export default component.exports